// extracted by mini-css-extract-plugin
export default {"zoomModal":"O2-z"};